export function isLocalStorageEnabled(): boolean {
    try {
        const key = `__storage__test`;
        window.localStorage.setItem(key, '');
        window.localStorage.removeItem(key);
        return true;
    } catch (e) {
        return false;
    }
}

export function isSessionStorageEnabled(): boolean {
    try {
        const key = `__storage__test`;
        window.sessionStorage.setItem(key, '');
        window.sessionStorage.removeItem(key);
        return true;
    } catch (e) {
        return false;
    }
}
